import React from 'react'
import {
  Cascader,
  Icon,
  Button,
  message,
  List
} from 'antd'

import CloudFlyerAPI from '../../../api/CloudFlyerAPI'
import { refresh_profile } from '../../../actions/auth'
import './styles.scss'

import warningIcon from '../../../assets/img/warning.png';
import ModalB from '../../../components/UI/Modal/ModalB';
import Backdrop from '../../../components/UI/Backdrop/Backdrop';

class HybrikSettings extends React.Component {

  state = {
    // Pup Up
    popUp:false,
    popUpMessage:{},

  }

  goBackOption = {
    value: 'go_back',
    label: [
      <Icon type='left' style={{ fontSize: '10px' }} />,
      ' ',
      <span className='go_back'>go back</span>
    ],
    isLeaf: false
  }

  componentDidMount() {
    const { hybrik_profiles_bucket } = this.props.user
    const hasHPBucket = hybrik_profiles_bucket &&
      Object.keys(hybrik_profiles_bucket).length >= 3
    this.setState({ hasHPBucket })
    CloudFlyerAPI
      .cloud_accounts
      .all()
      .then(({ data }) => {
        const options = data
          .filter(x => x.account_type_id === 'aws')
          .map(this.formatCloudAccount)
        if (hasHPBucket) {
          this.dataSource = this.formatHPBucket(options, hybrik_profiles_bucket)
        }
        this.setState({ options })
      })
      .catch(this.onError)
  }

  formatCloudAccount = (cloudAccount) => {
    return {
      value: cloudAccount.id,
      label: cloudAccount.project_name,
      children: cloudAccount.storages.map(this.formatStorage),
      ...cloudAccount
    }
  }

  formatStorage(storage) {
    return {
      value: storage.bucket_name,
      label: storage.bucket_name,
      isLeaf: true,
      ...storage
    }
  }

  formatDirectory(directory) {
    return {
      value: directory.id,
      label: directory.name,
      isLeaf: false
    }
  }

  loadData = (selectedOptions) => {
    if (selectedOptions.length === 1) {
      // do nothing on cloud account change
      return
    }
    const [
      selectedCloudAccount,
      selectedStorage,
      lastChild
    ] = selectedOptions
    let path
    if (selectedOptions.length === 3) {
      // load sub dirs on dir click
      const isGoBack = lastChild.value === 'go_back'
      path = isGoBack ? this.state.parent.value : lastChild.value
    } else {
      // load root dirs for bucket on storage select
      path = ''
    }

    CloudFlyerAPI
      .storages
      .directories(selectedStorage.cloud_account_id, selectedStorage.bucket_name, path)
      .then(({data:{items, out, id, bucket_name, path}}) => {
        if (items.length === 0) return
        const options = this.state.options.map(x => {
          // walk options and update leaf
          if (x.id === selectedCloudAccount.id) {
            x.children = x.children.map(y => {
              if (y.id === selectedStorage.id) {
                y.children = [
                  this.goBackOption,
                  ...items.map(this.formatDirectory),
                ]
              }
              return y
            })
          }
          return x
        })
        this.setState({ options, parent:{ path }})
      })
      .catch(this.onError)
  }

  onChange = (value) => {
    this.setState({
      hybrik_profiles_bucket: {
        cloud_account_id: value[0],
        bucket_name: value[1],
        path: value[2] || ''
      }
    })
  }

  displayRender(label) {
    // remove goback react element from value
    return label
      .filter(x => typeof x === 'string')
      .join('/')
  }

  formatHPBucket = (options, hybrik_profiles_bucket) => {
    return [{
      title: 'Cloud Account',
      description: (options
        .find(o => o.id === hybrik_profiles_bucket.cloud_account_id)||{})
        .project_name
    }, {
      title: 'Bucket Name',
      description: hybrik_profiles_bucket.bucket_name
    }, {
      title: 'Path To Folder',
      description: hybrik_profiles_bucket.path
    }]
  }

  onSubmit = () => {
    const { options, hybrik_profiles_bucket } = this.state
    CloudFlyerAPI
      .user_account
      .update({ hybrik_profiles_bucket })
      .then(() => {
        message.info('hybrik JSON configurations successfully updated.')
        this.props.dispatch(refresh_profile(true))
        this.dataSource = this.formatHPBucket(options, hybrik_profiles_bucket)
        this.toggleEdit()
      })
      .catch(this.onError)
  }

  onError(err) {
    console.log(err)
    // Adding Pop Up
    this.setState({
      popUp:true,
      popUpMessage:{
        icon:warningIcon,
        header:"Something Went Wrong",
        text:{
            1:"Please try again later.",
        },
        button:"OK"
      }
  })

    // message.error('Something went wrong, please try again later.')
  }

  //  to close the popUp using the backdrop and Ok
  ClosePopupHandler = () =>{
    this.setState({ popUp: false })
  }

  toggleEdit = () => {
    this.setState({ hasHPBucket: !this.state.hasHPBucket })
  }

  render() {

    // POP UPS
    const popUpComponent = this.state.popUp ? 
    <div>
        <Backdrop show={this.state.popUp} close={this.ClosePopupHandler}/>
        <ModalB 
            show={this.state.popUp}
            icon={this.state.popUpMessage.icon}
            header={this.state.popUpMessage.header}
            text={this.state.popUpMessage.text}
            button={this.state.popUpMessage.button}
            close={this.closePopUpHandler}
        /> 
    </div>:null;

    return (
      <div className='hybrik-settings'>
        {popUpComponent}
        {
          this.state.hasHPBucket
            ? ([
              <List
                key='list'
                bordered
                dataSource={this.dataSource}
                loading={!this.dataSource}
                renderItem={item => (
                  <List.Item>
                    <List.Item.Meta
                      title={item.title}
                      description={item.description}
                    />
                  </List.Item>
                )}
              />,
              <Button
                key='button'
                type='primary'
                icon='edit'
                children='Edit'
                style={{ float: 'right', marginTop: '16px' }}
                onClick={this.toggleEdit}
              />
            ]) : ([
              <p style={{ fontSize: '12px' }} key='p'>
                Select a bucket for hybrik JSON configurations:
              </p>,
              <div key='div'>
                <Cascader
                  size='large'
                  placeholder='Select a bucket for hybrik JSON configurations'
                  expandTrigger='hover'
                  options={this.state.options}
                  changeOnSelect
                  loadData={this.loadData}
                  onChange={this.onChange}
                  displayRender={this.displayRender}
                />
                <Button
                  type='primary'
                  icon='check'
                  onClick={this.onSubmit}
                >
                  Update
                  </Button>
              </div>
            ])
        }
      </div>
    )
  }
}

export default HybrikSettings

